import { newPageInfo } from "@hex-insights/router";
import { rootPageInfo } from "../../root.pageinfo";

export const reportsPageInfo = newPageInfo({
	title: "Reports",
	description: "Directory for reports.",
	exact: false,
	to: "/reports",
	path: "/reports",
	parent: rootPageInfo,
});
